import TabletFacesheetPage from "./TabletFacesheetPage";

export default TabletFacesheetPage;